import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexRating',
  setup(__props) {

const ClickableValue = defineAsyncComponent(() => import("@/components/theme/advance/rating/ClickableValue.vue"))
const MovieRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/MovieRating.vue"))
const HeartRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/HeartRating.vue"))
const StarRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/StarRating.vue"))
const DisabledRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/DisabledRating.vue"))
const AnimationRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/AnimationRating.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ClickableValue)),
      _createVNode(_unref(MovieRating)),
      _createVNode(_unref(HeartRating)),
      _createVNode(_unref(StarRating)),
      _createVNode(_unref(DisabledRating)),
      _createVNode(_unref(AnimationRating))
    ])
  ]))
}
}

})